import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import ModalidadeFreteService from "../../services/ModalidadeFreteService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormModalidadeFrete extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idModalidadeFrete: "",
            nome: ""
        };

        this.state.crud = {
            service: ModalidadeFreteService,
            labels: {
                title: 'Modalidade de Frete',
            },
            urlList: '/LstModalidadeFrete',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idModalidadeFrete} name="idModalidadeFrete" readOnly opcionalLabel={false} />
                <InputText label="Nome da ModalidadeFrete" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormModalidadeFrete {...props} navigate={navigate} params={params} />
}

export default With